import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M11.6962 16.1462a.5003.5003 0 01.707 0l3 3a.4985.4985 0 010 .707.5003.5003 0 01-.707 0l-2.146-2.146L12.55 22.5c0 .276-.2245.5-.5005.5a.499.499 0 01-.4994-.5l.0001-4.7927-2.147 2.146c-.195.195-.512.195-.707 0s-.195-.512 0-.707l3-3zm0-7.2924c.195.195.512.195.707 0l3-3a.4985.4985 0 000-.707.5003.5003 0 00-.707 0l-2.146 2.146L12.55 2.5c0-.276-.2245-.5-.5005-.5a.499.499 0 00-.4994.5l.0001 4.7927-2.147-2.146a.5003.5003 0 00-.707 0 .5003.5003 0 000 .707l3 3zM21.55 14.5a.5.5 0 00-.5-.5h-18a.5.5 0 100 1h18a.5.5 0 00.5-.5zm0-4a.5.5 0 00-.5-.5h-18a.5.5 0 100 1h18a.5.5 0 00.5-.5z',
  ],
  height: 24,
  width: 24,
});
